const URL_LOCALHOST = {
  identity: 'https://localhost:5000',
  academic: 'https://localhost:5000',
  gateway: 'https://localhost:5000',
};

const URL_DEV = {
  identity: 'https://amoxalligateway.runasp.net',
  academic: 'https://amoxalligateway.runasp.net',
  gateway: 'https://amoxalligateway.runasp.net',
};

const URL_PRODUCTION = {
  identity: 'https://amoxalligateway.runasp.net',
  academic: 'https://amoxalligateway.runasp.net',
  gateway: 'https://amoxalligateway.runasp.net',
};

export const SERVER_URL = {
  localhost:  URL_LOCALHOST,
  dev:        URL_DEV,
  production: URL_PRODUCTION,
};

export type ServerEnv = keyof typeof SERVER_URL;
